/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div>
    <p class="sr-only">
      Please note that users who are reliant on screen readers are recommended to use
      the recording functionality on the Record tab on this website, instead of
      installing and using the VoiceVibes mobile app. All functionality provided by
      our app is also available on this website, which has been tailored to provide the
      best experience possible to visitors utilizing screen readers.
    </p>
    <ol>
      <li>
        Download the <em>VoiceVibes Recorder App</em> for your Apple smartphone.<br>
        It's available <strong>for free</strong> on the App Store:<br>
        <div>
          <a
            href="https://itunes.apple.com/us/app/voicevibes-recorder/id1014688052?mt=8"
            target="_blank"
          >
            <img
              alt="Get it on Apple App Store"
              height="34"
              src="https://voicevibes.s3.amazonaws.com/static/images/iphone_App_Store_Badge.svg"
            >
          </a>
        </div>
      </li>
      <li>
        Once the app is installed on your device, use it to record your speech<br>
        <small>
          Note: there is a <em>15 minute</em> recording limit and <em>200 MB</em> file size limit.
          Acceptable audio formats are .wav, .mp3 and .m4a. Video is not available at this time.
        </small>
      </li>
      <li>
        Upload your speech from your smartphone, making sure you have labeled it first.  You can do this for as many speeches as you wish.
      </li>
    </ol>
    <p>
      Once speeches are uploaded, you can view your speech's evaluation on this site.
    </p>
  </div>
</template>

<style lang="less" scoped>
</style>

<script>
export default {
  data() {
    return {
    };
  }
};
</script>
